<template>
  <div class="system-builder__contact-dealer--dealer-item">
    <div class="system-builder__contact-dealer--dealer-content">
      <div class="dealer-details">
        <slot name="dealer-details"></slot>
      </div>

      <div class="pro-logo" v-if="dealerPro === 'PRO'">
      </div>
    </div>
    <div class="system-builder__contact-dealer--dealer-cta-container">
      <div class="button__outline--primary" v-if="dealerPhone !== false"><a
          :href="prepareTelLink(dealerPhone)">Call</a>
      </div>

      <div class="button__outline--disabled" v-if="parseInt(sharedState.numberQuotesRequested) >= 5 && dealerEmail">
        <div><i class="fa fa-times-circle-o" aria-hidden="true"></i> Send Limit Reached</div>
      </div>

      <div class="button__solid--blue" v-else-if="dealerEmail && emailButtonLoading">
        <spinner size="small" message=""></spinner>
      </div>

      <div class="button__outline--disabled" v-else-if="dealerEmail && emailSent">
        <div><i class="fa fa-check-circle" aria-hidden="true"></i> Sent</div>
      </div>

      <div class="button__solid--blue" v-else-if="dealerEmail && emailSent === false" @click="sendQuoteToDealer()">
        <div>Get E-Quote</div>
      </div>

    </div>
  </div>
</template>

<script>
  import store from '../../store/index'
  import spinner from 'vue-simple-spinner'
  import $ from 'jquery'

  export default {
    name: 'dealerItem',
    props: ['dealerId', 'dealerPro', 'dealerPhone', 'dealerEmail'],
    components: {spinner},
    data () {
      return {
        sharedState: store.state,
        dealerId: this.dealerId,
        dealerPro: this.dealerPro,
        dealerPhone: this.dealerPhone,
        dealerEmail: this.dealerEmail,
        emailButtonLoading: false,
        emailSent: false
      }
    },
    methods: {
      sendQuoteToDealer: function () {
        this.emailButtonLoading = true
        var self = this

        var ajaxUrl = 'https://' + window.location.hostname + '/wp-admin/admin-ajax.php'

        $.ajax({
          url: ajaxUrl,
          type: 'POST',
          dataType: 'text',
          data: {
            action: 'system-builder-send-quote-request',
            dealerId: this.dealerId,
            inquiryId: this.sharedState.inquiryId
          },
          cache: false,
          success: function (response) {
            // Update button state
            self.changeEmailButtonToSent()

            // Update number of requests on state
            store.updateNumberQuotesRequested()
            return false
          },
          error: function (err) {
            console.log('AJAX error in request: ' + JSON.stringify(err, null, 2))
          }
        })
      },
      changeEmailButtonToSent: function () {
        this.emailButtonLoading = false
        this.emailSent = true
      },
      prepareTelLink: function (val) {
        return 'tel:' + val
      }
    },
    mounted: function () {
      store.getRequestNumberFromStorage()
    }
  }
</script>



// WEBPACK FOOTER //
// DealerItem.vue?1137e9ec